import { Injectable } from '@angular/core';
import * as OlogMessageActions from './olog-message.action';
import { Store } from '@ngxs/store';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';


@Injectable({
  providedIn: 'root'
})
export class OlogMessageStoreAndListenersService {

  constructor(
    private store: Store,
    private signalRService: SignalRService
  ) { }

  initStore() {
    this.store.dispatch(new OlogMessageActions.OlogMessageRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.OLOG_MESSAGE, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new OlogMessageActions.OlogMessageCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new OlogMessageActions.OlogMessageUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new OlogMessageActions.OlogMessageDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new OlogMessageActions.OlogMessageRefresh());
      }
    });
  }
}
